import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Route, BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import App from './app';

import { fetchExperiences } from './query/experience';
import { fetchRestaurant, fetchPaymentData } from './query/restaurant';
import { featureToggle } from './query/toggle';
import { createTransaction } from './query/transaction';
import { purchaseGiftCard, fetchOrderSituation } from './query/payment';

import { defaultNotify } from './constants/notify';

import './assets/stylesheets/index.scss';

const queryClient = new QueryClient({
    refetchOnWindowFocus: false,
});

// MUTATIONS
queryClient.setMutationDefaults('restaurant-mutation', {
    mutationFn: (slug) => fetchRestaurant(slug),
    onSuccess: (data) => queryClient.setQueryData('restaurant', data),
    onError: () => queryClient.setQueryData('restaurant', {}),
});

queryClient.setMutationDefaults('payment-mutation', {
    mutationFn: (slug) => fetchPaymentData(slug),
    onSuccess: (data) => queryClient.setQueryData('payment', data),
    onError: () => queryClient.setQueryData('payment', {}),
});

queryClient.setMutationDefaults('language-mutation', {
    mutationFn: (lang) => lang,
    onSuccess: (data) => queryClient.setQueryData('language', data),
    onError: () => queryClient.setQueryData('language', 'en'),
});

queryClient.setMutationDefaults('feature-toggle-mutation', {
    mutationFn: (id) => featureToggle(id),
    onSuccess: (data) => queryClient.setQueryData('featureToggle', data),
    onError: () => queryClient.setQueryData('featureToggle', {}),
});

queryClient.setMutationDefaults('experiences-mutation', {
    mutationFn: (id) => fetchExperiences(id),
    onSuccess: (data) => {
        const experiences = data.map((e) => ({ ...e, color: Math.floor(Math.random() * 7) }));
        queryClient.setQueryData('experiences', experiences);
    },
    onError: () => queryClient.setQueryData('experiences', []),
});

queryClient.setMutationDefaults('transaction-mutation', {
    mutationFn: (order) => createTransaction(order),
    onSuccess: (data) => {
        queryClient.setQueryData('transaction', data);
    },
    onError: () => queryClient.setQueryData('transaction', []),
});

queryClient.setMutationDefaults('purchase-mutation', {
    mutationFn: (order) => purchaseGiftCard(order),
    onSuccess: (data) => {
        queryClient.setQueryData('purchase', data);
    },
    onMutate: (data) => {
        queryClient.setQueryData('purchase', []);
    },
    onError: (error) => {
        queryClient.setQueryData('purchase', { error: true });
    },
});

queryClient.setMutationDefaults('order-mutation', {
    mutationFn: (order) => fetchOrderSituation(order),
    onSuccess: (data) => {
        queryClient.setQueryData('order', data);
    },
    onError: (error) => queryClient.setQueryData('order', []),
});

// INITIAL DATA
queryClient.setQueryData('app', { toggleBag: false });
queryClient.setQueryData('language', 'en');
queryClient.setQueryData('notify', defaultNotify);
queryClient.setQueryData('items', [Math.floor(Math.random() * 7)]);
queryClient.setQueryData('bag', []);

ReactDOM.render(
    <QueryClientProvider client={queryClient}>
        <BrowserRouter history={createBrowserHistory()}>
            <Route path="/:slug" component={App} />
        </BrowserRouter>
    </QueryClientProvider>,
    document.getElementById('root'),
);
